import { II18nLanguageObj } from '../hooks/useLanguage';
import CashPaymentBlock from './CashPaymentBlock';
import StripePaymentBlock from './StripePaymentBlock';

export interface PaymentBlockProps {
    order: any;
    allOrders: any[];
    paymentMethod: {
        slug: string;
        name: string;
        nameI18n: II18nLanguageObj;
        methodType: string;
        methodInfo: Record<string, any>;
    };
    onStartTransaction: (paymentInfo: Record<string, any>) => Promise<void>;
    onCancel?: () => void;
    amount?: number;
    maxAmount?: number;
}

function PaymentBlock({
    order,
    allOrders,
    paymentMethod,
    onStartTransaction,
    onCancel,
    amount,
    maxAmount,
}: PaymentBlockProps) {
    const passProps = {
        order,
        allOrders,
        paymentMethod,
        onStartTransaction,
        onCancel,
        amount,
        maxAmount,
    };
    // based on the paymentMethod.paymentType, this is a simple switch
    switch (paymentMethod.methodType) {
        // net_rate is charged as an ordinary guest card payment (the booking is
        // already priced at net); it reuses the Stripe card entry UI.
        case 'stripe':
        case 'net_rate':
            return <StripePaymentBlock {...passProps} />;
        case 'cash':
            return <CashPaymentBlock {...passProps} />;
    }
    return <div>Unknown payment method: {JSON.stringify(paymentMethod)}</div>;
}

export default PaymentBlock;
